import Vue from 'vue';
import { sendEvent } from '@/helpers/gtm';

const form = {
  namespaced: true,
  state: {
    uuid: null,
    meta: null,
    content: null,
    requests: 0,
    sending: false,
    response: null,
    saved: null,
    filesSize: 0
  },
  mutations: {
    update(state, { prop, value }) {
      state[prop] = value;
    },
    updateValue(state, { index, value }) {
      state.content.data[index].value = value;
    },
    updateError(state, { index, error }) {
      state.content.data[index].error = error;
    },
    updateVisibility(state, { index, visibility }) {
      state.content.data[index].isVisible = visibility;
    },
    updateSending(state, flag) {
      state.sending = flag;
    },
    updateResponse(state, response) {
      state.response = response;
    },
    updateContent(state, content) {
      state.content = content;
    },
    updateUUID(state, uuid) {
      state.uuid = uuid;
    },
    updateRequests(state, type) {
      state.requests = type === 'dec' ? state.requests - 1 : state.requests + 1;
    },
    updateSaved(state, data) {
      state.saved = data;
    },
    clear(state) {
      state.content = null;
      state.response = null;
      state.sending = false;
    },
    updateFilesSize(state) {
      const inputs = state.content.data.filter(question => question.type === 'file')
      // eslint-disable-next-line
      const visibles = inputs.filter(question => !question.hasOwnProperty('isVisible') || question.isVisible);
      let size = 0;

      visibles.map((question) => {
        question.value.map((file) => {
          size = size + file.size;
        });
      });

      size = size / 1000000;
      size = Math.round((size + Number.EPSILON) * 100) / 100;
      state.filesSize = size;
    }
  },
  actions: {
    formatForm({ rootState, commit }, content) {
      content.data.map((question) => {
        question.title = question.title[rootState.locale].trim();
        question.description = question.description && question.description[rootState.locale] ? question.description[rootState.locale].trim() : null;
        if (question.description) question.description = question.description.replace(/\[([^\[]+)\](\(([^)]*))\)/gim, '<a href="$3" target="_blank">$1</a>');
        Vue.set(question, 'error', null);

        if (question.answers) {
          question.answers = question.answers.map((answer) => {
            answer.label = answer.label[rootState.locale];
            return answer;
          });
        }

        if (question.type === 'checkbox' || question.type === 'file') {
          Vue.set(question, 'value', []);
        } else {
          if (question.id === 'question-lawyer' && question.answers.length === 1) {
            Vue.set(question, 'value', question.answers[0].value);
          } else {
            Vue.set(question, 'value', '');
          }
        }

        if (question.visibility) {
          Vue.set(question, 'isVisible', false);
        }

        if (question.id === 'question-lawyer') {
          const urlParams = new URLSearchParams(window.location.search);
          let selected = urlParams.get('pre-select');

          if (selected) {
            selected = Number(selected);
            const lawyer = question.answers.find((l) => l.value === selected);
            if (lawyer) {
              question.value = selected;
              Vue.set(question, 'isVisible', false);
            }
          }
        }

        return question;
      });

      commit('updateContent', content);
    },
    checkSaved({ state, commit }) {
      if (state.saved && state.saved.uuid === state.uuid) {
        state.content.data.map((question, index) => {
          if (state.saved.data[question.id]) {
            commit('updateValue', {
              index,
              value: state.saved.data[question.id]
            });
          }
        });
      }
    },
    // eslint-disable-next-line
    async getForm({ rootState, dispatch, commit }, ids) {
      commit('updateRequests');
      const lawyers = rootState.lawyer.item.mail_system === 2 ? rootState.lawyer.item.lawyer_list : null;

      try {
        const request = await dispatch('calls/form', {...ids, lawyers}, { root: true });
        
        if (request.status === 'success') {
          commit('updateUUID', request.data.data.uuid);
          commit('update', { prop: 'meta', value: request.data.data.content.meta });
          dispatch('formatForm', request.data.data.content);
        }
        commit('updateRequests', 'dec');
        return true;
      } catch (error) {
        commit('updateRequests', 'dec');
        return error;
      }
    },
    async sendFiles({ dispatch }, files) {
      const IDs = [];

      for (let i = 0; i < files.length; i++) {
        try {
          const data = await dispatch('calls/sendFile', files[i], { root: true });
          IDs.push(data);
        } catch (error) {
          // throw new Error(error);
          return [];
        }
      }

      return IDs;
    },
    async sendFile({ dispatch }, file) {
      try {
        const data = await dispatch('calls/sendFile', file, { root: true });
        return data;
      } catch (error) {
        return null;
      }
    },
    async send({ commit, dispatch }, data) {
      commit('updateSending', true);
      const request = await dispatch('calls/sendForm', data, { root: true });

      if (request.status === 'success') {
        sendEvent('symplicy:form_sent');
        commit('updateResponse', request.data);
      } else {
        commit('updateResponse', request.error);
      }

      commit('updateSending', false);
    }
  }
};

export default form;
